export default {
  on: true,
  cache: true,
  auth: true,
  intercept: false,
  keepAlive: false,
  dynamicParam: '/:mode?/:id?',
  title: '新增返利规则',
} as TCommon.RouteConfig
